import { Hotkeys, HotkeysActions, HotkeysBindings } from '../../../../../services/user/userSettingsTypes';
import Hotkey from './Hotkey';

interface HotkeysSectionProps {
  hotkeys: Hotkeys;
  setHotkeysConfiguration: React.Dispatch<React.SetStateAction<Hotkeys | undefined>>;
}

const allowedHotkeysActions: HotkeysActions[] = ['call', 'fold', 'betOrRaise'];

const HotkeysSection = ({ hotkeys, setHotkeysConfiguration }: HotkeysSectionProps) => {
  const assignHotkey = (action: string, newHotkey: HotkeysBindings) => {
    setHotkeysConfiguration((prevHotkeys) => {
      if (!prevHotkeys) return prevHotkeys;

      if (action === 'check' || action === 'call') {
        return {
          ...prevHotkeys,
          check: newHotkey,
          call: newHotkey,
        };
      }

      return {
        ...prevHotkeys,
        [action]: newHotkey,
      };
    });
  };

  return (
    <div className="flex w-fit flex-wrap gap-2">
      {Object.entries(hotkeys)
        .filter(([key]) => allowedHotkeysActions.includes(key as HotkeysActions))
        .sort(([keyA], [keyB]) => keyB.localeCompare(keyA))
        .map(([key, hotkey]) => {
          return (
            <Hotkey
              key={key}
              action={key as HotkeysActions}
              {...hotkey}
              assignHotkey={assignHotkey}
              existingHotkeys={hotkeys}
            />
          );
        })}
    </div>
  );
};

export default HotkeysSection;
